// SVGs for grid filter icons
// These icons are not available in the Airbus Design system but are called from the MUI library
export const deleteFilledSvg = `
  <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall custom-delete-filled"
    focusable="false" aria-hidden="true"
    viewBox="0 0 24 24" width="20" height="20" style="vertical-align:middle;">
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
  </svg>
`;

export const deleteOutlineSvg = `
  <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall custom-delete-outline"
    focusable="false" aria-hidden="true"
    viewBox="0 0 24 24" width="20" height="20" style="vertical-align:middle;">
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4zM8 9h8v10H8V9z"/>
  </svg>
`;

export const checkIconSvg = `
  <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall custom-check-icon"
    focusable="false" aria-hidden="true"
    viewBox="0 0 24 24" width="20" height="20" style="vertical-align:middle;margin-right:4px;">
    <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/>
  </svg>
`;
